var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TextEditor',{attrs:{"entity":_vm.form,"label":"Navn","alias":"name","validate":true,"scope":"contact"}}),_c('UserPicker',{attrs:{"entity":_vm.form,"label":"Oprettet af","alias":"owner","values":_vm.$users,"validate":true,"scope":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }